module.exports = __webpack_public_path__ + "static/media/HSeries.9ff4ce93.png";